// B2 - Ünite 5: Reported Speech
// Hedef: Dolaylı anlatım: He said, She asked, He told me

export const B2_UNIT_5 = {
  'B2-U5-L1': {
    id: 'B2-U5-L1',
    title: 'Say vs Tell',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Say vs Tell',
          table: {
            headers: ['Say', 'Tell'],
            rows: [
              ['say + (that) + clause', 'tell + person + (that) + clause'],
              ['She said (that) she was tired.', 'She told me (that) she was tired.'],
              ['He said he would help.', 'He told them he would help.'],
              ['Kişi belirtilmez', 'Kişi belirtilir (me, him, her, them)']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Direct', 'Say', 'Tell'],
            rows: [
              ['"The flight is delayed."', 'He said the flight was delayed.', 'He told us the flight was delayed.'],
              ['"Please fasten your seatbelts."', 'She said to fasten seatbelts.', 'She told passengers to fasten seatbelts.'],
              ['"I will help you."', 'He said he would help.', 'He told me he would help.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 SAY = kişi yok | TELL = kişi VAR (told me, told him, told them)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'She _____ that she was tired.',
          options: ['said', 'told', 'say', 'tell'],
          correct: 'said',
          explanation: 'Kişi yok → said'
        },
        {
          type: 'multipleChoice',
          question: 'She _____ me that she was tired.',
          options: ['told', 'said', 'tell', 'say'],
          correct: 'told',
          explanation: 'Kişi var (me) → told'
        },
        {
          type: 'timeRace',
          title: '⏱️ Said mi Told mı?',
          cards: [
            { front: 'She ___ that...', back: 'said' },
            { front: 'She ___ me that...', back: 'told' },
            { front: 'He ___ he would come', back: 'said' },
            { front: 'He ___ them to wait', back: 'told' },
            { front: 'They ___ the news', back: 'said' },
            { front: 'They ___ us the news', back: 'told' }
          ]
        }
      ]
    }
  },
  'B2-U5-L2': {
    id: 'B2-U5-L2',
    title: 'Reporting Statements',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Tense Changes (Backshift)',
          explanation: 'Reported speech\'te zamanlar bir adım geriye kayar.',
          table: {
            headers: ['Direct Speech', 'Reported Speech'],
            rows: [
              ['Present Simple: "I work here."', 'Past Simple: He said he worked there.'],
              ['Present Continuous: "I am working."', 'Past Continuous: He said he was working.'],
              ['Past Simple: "I worked."', 'Past Perfect: He said he had worked.'],
              ['Will: "I will help."', 'Would: He said he would help.'],
              ['Can: "I can do it."', 'Could: He said he could do it.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📚 Time/Place Changes',
          table: {
            headers: ['Direct', 'Reported'],
            rows: [
              ['today', 'that day'],
              ['tomorrow', 'the next day'],
              ['yesterday', 'the day before'],
              ['here', 'there'],
              ['this', 'that'],
              ['now', 'then']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Present → Past | Past → Past Perfect | Will → Would | Can → Could'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '"I work here." → She said she _____ there.',
          options: ['worked', 'works', 'work', 'working'],
          correct: 'worked',
          explanation: 'Present Simple → Past Simple'
        },
        {
          type: 'multipleChoice',
          question: '"I will help." → He said he _____ help.',
          options: ['would', 'will', 'can', 'could'],
          correct: 'would',
          explanation: 'Will → Would'
        },
        {
          type: 'flashcard',
          title: '🎴 Tense Changes',
          cards: [
            { front: 'Present Simple →', back: 'Past Simple' },
            { front: 'Present Continuous →', back: 'Past Continuous' },
            { front: 'Past Simple →', back: 'Past Perfect' },
            { front: 'Will →', back: 'Would' },
            { front: 'Can →', back: 'Could' }
          ]
        }
      ]
    }
  },
  'B2-U5-L3': {
    id: 'B2-U5-L3',
    title: 'Reporting Questions',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Yes/No Questions',
          explanation: 'Yes/No soruları "if" veya "whether" ile raporlanır.',
          table: {
            headers: ['Direct Question', 'Reported Question'],
            rows: [
              ['"Are you a cabin crew?"', 'She asked if I was a cabin crew.'],
              ['"Do you speak English?"', 'He asked whether I spoke English.'],
              ['"Can you help?"', 'She asked if I could help.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📚 WH Questions',
          table: {
            headers: ['Direct Question', 'Reported Question'],
            rows: [
              ['"Where do you work?"', 'He asked where I worked.'],
              ['"What time is the flight?"', 'She asked what time the flight was.'],
              ['"Why are you late?"', 'He asked why I was late.']
            ]
          }
        },
        {
          type: 'tip',
          content: '⚠️ Reported questions\'ta soru sırası KULLANILMAZ: "Where do you work?" → He asked where I worked. (NOT: where did I work)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '"Do you speak English?" → She asked _____ I spoke English.',
          options: ['if', 'that', 'what', 'do'],
          correct: 'if',
          explanation: 'Yes/No soru → if/whether'
        },
        {
          type: 'multipleChoice',
          question: '"Where do you live?" → He asked where I _____.',
          options: ['lived', 'live', 'do live', 'did live'],
          correct: 'lived',
          explanation: 'Present → Past, soru sırası yok'
        },
        {
          type: 'dragDrop',
          instruction: '🔀 Cümleyi doğru sıraya dizin',
          words: ['asked', 'She', 'I', 'if', 'was', 'ready'],
          correctOrder: [1, 0, 3, 2, 4, 5],
          translation: 'Hazır mıyım diye sordu.'
        }
      ]
    }
  },
  'B2-U5-L4': {
    id: 'B2-U5-L4',
    title: 'Reporting Commands',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Commands ve Requests',
          explanation: 'Emirler "told/asked + person + to + fiil" ile raporlanır.',
          table: {
            headers: ['Direct', 'Reported'],
            rows: [
              ['"Fasten your seatbelt."', 'She told me to fasten my seatbelt.'],
              ['"Please sit down."', 'He asked me to sit down.'],
              ['"Don\'t smoke."', 'She told them not to smoke.'],
              ['"Please don\'t stand."', 'He asked us not to stand.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Direct', 'Reported'],
            rows: [
              ['"Return to your seats."', 'The captain told passengers to return to their seats.'],
              ['"Please turn off your phones."', 'The crew asked us to turn off our phones.'],
              ['"Don\'t leave your bags unattended."', 'Security told us not to leave bags unattended.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Emir: told + to | Rica: asked + to | Olumsuz: told/asked + not to'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '"Fasten your seatbelt." → She told me _____ my seatbelt.',
          options: ['to fasten', 'fasten', 'fastening', 'fastened'],
          correct: 'to fasten',
          explanation: 'Command: told + to + fiil'
        },
        {
          type: 'multipleChoice',
          question: '"Don\'t smoke." → She told them _____ smoke.',
          options: ['not to', 'to not', 'don\'t', 'didn\'t'],
          correct: 'not to',
          explanation: 'Olumsuz: not to + fiil'
        },
        {
          type: 'fillInBlank',
          sentence: '"Please sit down." → He asked me _____ sit down.',
          answer: 'to',
          hint: 'Request: asked + to + fiil'
        }
      ]
    }
  },
  'B2-U5-L5': {
    id: 'B2-U5-L5',
    title: 'Uygulama: Bilgi Aktarma',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📝 Bilgi Aktarma Örnekleri',
          table: {
            headers: ['Durum', 'Direct', 'Reported'],
            rows: [
              ['Yolcu sorusu', '"Is there a delay?"', 'The passenger asked if there was a delay.'],
              ['Kaptan anonsu', '"We will land in 30 minutes."', 'The captain said we would land in 30 minutes.'],
              ['Ekip talimatı', '"Please remain seated."', 'The crew asked us to remain seated.']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '🎤 Mülakata Reported Speech',
          words: [
            { en: 'The interviewer asked me why I wanted to be a cabin crew.', tr: 'Mülakatcı neden kabin memuru olmak istediğimi sordu.', pronunciation: '' },
            { en: 'She asked if I had any experience.', tr: 'Deneyimim olup olmadığını sordu.', pronunciation: '' },
            { en: 'He told me to describe a difficult situation.', tr: 'Zor bir durumu anlatmamı söyledi.', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'speaking',
          instruction: 'Bu cümleleri sesli okuyun:',
          phrases: [
            'The captain said we would land soon.',
            'She asked if I spoke English.',
            'He told me to remain calm.',
            'The crew asked passengers to fasten seatbelts.'
          ]
        }
      ]
    }
  },
  'B2-U5-EXAM': {
    id: 'B2-U5-EXAM',
    title: 'Ünite 5 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'She _____ that she was tired.',
        options: ['said', 'told', 'say', 'tell'],
        correct: 'said',
        explanation: 'Kişi yok → said'
      },
      {
        type: 'multipleChoice',
        question: 'She _____ me that she was tired.',
        options: ['told', 'said', 'tell', 'say'],
        correct: 'told',
        explanation: 'Kişi var (me) → told'
      },
      {
        type: 'multipleChoice',
        question: '"I work here." → He said he _____ there.',
        options: ['worked', 'works', 'work', 'working'],
        correct: 'worked',
        explanation: 'Present → Past'
      },
      {
        type: 'multipleChoice',
        question: '"Do you speak English?" → She asked _____ I spoke English.',
        options: ['if', 'that', 'what', 'do'],
        correct: 'if',
        explanation: 'Yes/No soru → if'
      },
      {
        type: 'multipleChoice',
        question: '"Fasten your seatbelt." → She told me _____ my seatbelt.',
        options: ['to fasten', 'fasten', 'fastening', 'fastened'],
        correct: 'to fasten',
        explanation: 'Command: told + to + fiil'
      },
      {
        type: 'matchPairs',
        instruction: 'Tense değişimlerini eşleştirin',
        pairs: [
          { left: 'Present Simple', right: 'Past Simple' },
          { left: 'Will', right: 'Would' },
          { left: 'Can', right: 'Could' },
          { left: 'Past Simple', right: 'Past Perfect' }
        ]
      }
    ]
  }
};

export default B2_UNIT_5;
